<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Henvendelse" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details' && entity._embedded.contact && entity._embedded.contact.details && entity._embedded.contact.details != ''">
					<info-view>{{ entity._embedded.contact ? entity._embedded.contact.details : '' }}</info-view>
				</div>
				<div v-show="active == 'details'">
					<select-view label="Afdeling" v-model="entity.department_id" :options="departments" optionValueName="id" />
					<employee-select-view v-model="entity" label="Ansvarlig" :optional="true" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Status" v-model="entity.status" :options="status" :optional="true" optionValueName="name" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Motivation" v-model="entity.motivation" :options="motivations" :optional="true" optionValueName="name" />
				</div>
				<div v-show="active == 'details'">
					<contact-select-view v-model="entity" label="Kunde" :optional="true" />
					<select-view label="Type" v-model="entity.details.type" :options="[
						{
							label: 'Privat',
							value: 'private'
						},
						{
							label: 'Erhverv',
							value: 'business'
						}
					]" />
				</div>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.name" />
					<string-view label="Telefon" :optional="true" v-model="entity.phone" />
					<string-view label="E-mail" :optional="true" v-model="entity.email" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Flyttedato" v-model="entity.details.date" :controller="$store.state.popupController" />
					<text-view label="Beskrivelse" v-model="entity.comments" :height="180" />
				</div>
				<address-view v-show="active == 'address'" v-model="entity.details.address" :contact_id="entity.contact_id" />
				<div v-show="active == 'address'">
					<string-view label="Areal" :optional="true" v-model="entity.details.area" />
				</div>
				<address-view v-show="active == 'dest'" v-model="entity.details.dest" :contact_id="entity.contact_id" :optional="['address', 'zip', 'city', 'country']" />
				<div v-show="active == 'contact'">
					<div class="side-window__heading">
						Har sendt e-mail med timepriser
						<switch-array-view name="email_rates" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Har sendt e-mail med aftale om besigtigelse
						<switch-array-view name="email_survey" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Har sendt e-mail med anden information
						<switch-array-view name="email_info" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Har ringet og lagt en besked
						<switch-array-view name="phone_message" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Har sendt videre til anden medarbejder
						<switch-array-view name="forwarded" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Kunden svarer ikke
						<switch-array-view name="no_answer" v-model="entity.contact" />
					</div>
					<div class="side-window__heading">
						Kunden vender tilbage
						<switch-array-view name="pending" v-model="entity.contact" />
					</div>
				</div>
				<div v-show="active == 'tasks'">
					<task-list-view v-model="entity._embedded.tasks" :template="{
						department_id: entity.department_id,
						contact_id: entity.contact_id,
						employee_id: entity.employee_id,
						_embedded: {
							employee: entity._embedded.employee
						}
					}" :mask="['survey']" />
				</div>
				<div v-show="active == 'files'">
					<file-list-view v-model="entity.details.files" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import TaskListView from '../views/TaskListView';
	import AddressView from '../views/AddressView';

	import LeadModel from '../model/Lead'

	import merge from '../functions/merge'

	export default {
		data: function () {
			return {
				entity: {
					details: {},
					contact: [],
					_embedded: {}
				},
				//packaging: [],
				//ORDER: [],
				active: 'details',
				//instructions: [],
				departments: [],
				motivations: [],
				status: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'address',
						label: 'Fra'
					},
					{
						name: 'dest',
						label: 'Til'
					},
					{
						name: 'contact',
						label: 'Udført'
					},
					{
						name: 'files',
						label: 'Filer'
					},
					/*{
						name: 'tasks',
						label: 'Opgaver'
					}*/
				];
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			value: {
				type: Object,
				default() {
					return merge({}, LeadModel.entity());
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				// Has to have respinsible
				if (this.entity.employee_id === null) {
					alert("Du skal tilknytte en ansvarlig");
					return;
				}

				
				this.submit(merge({}, this.entity));
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/leads/motivations/')
				.then(function (r) {
					self.motivations = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/leads/status/')
				.then(function (r) {
					self.status = r.data._items;
					//self.departments = r.data._items;
				});

			


			this.entity = merge(LeadModel.entity(), this.value);


			

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
